import {initWebComponent} from "@/helpers/web-component-helper";
import Chart from 'chart.js/auto';
import {getLength} from "ol/sphere";
import {postGeoAhn} from "@/http/services/http-services-geo.js";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper.js";
import {getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper.js";
import {removeLayer} from "@/helpers/ol/ol-layer-helper.js";
import toastr from "toastr";
import {deselectFeature, selectFeature} from "@/modules/ol/service/ol-service-wfs.js";
import {Style} from "ol/style";

export class LayerInfoInfoItemGeometryMeasureAhnProfileComponent extends HTMLElement {
    constructor(){
        super();

        const geometryType = this.getAttribute('data-geometry-type')

        const template = document.createElement('template');

        template.innerHTML = `
                        <div class="row">
                           <div class="col-6 mt-2">Tussenafstand</div>
                           <div class="col-6">
                               <div class="input-group">
                                  <input type="text" class="form-control" value="1">
                                  <span class="input-group-prepend">
                                    <span class="input-group-text pl-2 pr-2">m</span>
                                  </span>
                                  <span class="input-group-append">
                                    <button class="btn btn-xs btn-default" data-type="show" type="button">Laat zien</button>
                                    <button class="btn btn-xs btn-default d-none" data-type="remove" type="button">Verbergen</button>
                                  </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
<!--                             <div class="col-6 mt-2">Nog ophalen</div>-->
                             <div class="col-6 mt-2 d-none" id="spnTotalCalls"></div>
                             <div class="col-12 mt-2">
                               <div id="divProgressTotalCalls" class="progress d-none" style="height:10px">
                                  <div id="progressTotalCalls" class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-none" id="divChart">
                            <div class="col-12">
                                <div class="chart-container" style="position: relative;">
                                    <canvas id="cvsChart"></canvas>
                                </div>                                
                            </div>
                            <div class="col-12">
                                <button data-type="download" href="" class="btn btn-xs btn-default btn-block mt-1">Open in nieuw venster</button>
                            </div>
                        </div>
                    </div>`

        initWebComponent(this, template)

        const progressTotalCalls = this.querySelector('#progressTotalCalls')

        let chart

        this.addEventListener('click', (e) => {

            if(!e.target.getAttribute('data-type')) {
                return
            }
            if(e.target.getAttribute('data-type') === 'download') {
                const canvas = document.getElementById("cvsChart");

                canvas.toBlob(blob => {
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                });
            } else if(e.target.getAttribute('data-type') === 'remove') {
                hideElementsBySelector('#divChart')

                this.querySelector('button[data-type="show"]').classList.remove('d-none')
                this.querySelector('button[data-type="remove"]').classList.add('d-none')

                this.querySelector('input').value = 1

                removeLayer('ahn-profile', false)

                progressTotalCalls.style.width = '0%'

                hideElementsBySelector('#divProgressTotalCalls')
            } else {

                this.querySelector('button[data-type="remove"]').classList.remove('d-none')
                this.querySelector('button[data-type="show"]').classList.add('d-none')

                const feature = window.measureOlFeature.clone()
                const geometry = feature.getGeometry()

                const length = getLength(geometry)
                const spacing = this.querySelector('input').value
                let numbers = length / spacing

                if (numbers > 1000) {
                    toastr.warning('Hiermee worden er meer dan ' + numbers.toFixed(0) + ' punten opgehaald. Probeer een lagere tussenafstand')
                    return
                }

                getBySelector('#spnTotalCalls').innerHTML = numbers.toFixed(0)

                const promises = []
                window.features = []
                const segments = []

                let totalSpacing = 0
                // Calculate points for each segment
                geometry.forEachSegment((start, end) => {
                    segments.push([start, end])
                    const distanceX = start[0] - end[0];
                    const distanceY = start[1] - end[1];
                    const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);


                    if (distance > spacing) {

                        const totalPoints = distance / spacing;

                        for (let i = 1; i < totalPoints; i++) {

                            totalSpacing = parseInt(totalSpacing) + parseInt(spacing)

                            const newX = parseFloat(start[0]) - i * parseFloat(distanceX) / totalPoints;
                            const newY = parseFloat(start[1]) - i * parseFloat(distanceY) / totalPoints;

                            features.push(
                                new Feature({
                                    index: features.length + 1,
                                    geometry: new Point([newX, newY]),
                                    spacing: totalSpacing
                                })
                            )

                            promises.push(generateSegment(newX, newY))
                        }
                    }
                })

                // Add first and last segment
                const firstSegment = segments[0]
                const firstSegmentX = firstSegment[0][0]
                const firstSegmentY = firstSegment[0][1]

                const lastSegment = segments[segments.length - 1]
                const lastSegmentX = lastSegment[1][0]
                const lastSegmentY = lastSegment[1][1]

                features.unshift(
                    new Feature({
                        index: 0,
                        geometry: new Point([firstSegmentX, firstSegmentY]),
                        spacing: 0
                    })
                )
                promises.unshift(generateSegment(firstSegmentX, firstSegmentY))

                features.push(
                    new Feature({
                        index: features.length,
                        geometry: new Point([lastSegmentX, lastSegmentY]),
                        spacing: parseInt(totalSpacing) + parseInt(spacing)
                    })
                )
                promises.push(generateSegment(lastSegmentX, lastSegmentY))

                // Set chart parameters
                const labels = []
                const data = []

                showElementsBySelector('#divProgressTotalCalls')
                let numberCount = 0
                // Call API
                promises.map((promise, i) => {
                    promise.then(result => {
                        if (result && result !== '""') {

                            const height = parseFloat(result).toFixed(2)
                            // totalHeight = (parseInt(totalHeight) + parseInt(height)).toFixed()
                            labels[i] = features[i].get('spacing')

                            data[i] = height
                        }

                        const width = numberCount.toFixed(0) / numbers.toFixed(0) * 100

                        progressTotalCalls.style.width = width + '%'

                        getBySelector('#spnTotalCalls').innerHTML = numbers.toFixed(0)
                        numberCount++
                    })
                })

                // Wait for all api calls to finish and create chart
                Promise.all(promises).then(() => {

                    progressTotalCalls.style.width = '100%'

                    hideElementsBySelector('#divProgressTotalCalls')

                    showElementsBySelector('#divChart')

                    removeLayer('ahn-profile', false)

                    getBySelector('#spnTotalCalls').innerHTML = 0

                    const ctx = document.getElementById('cvsChart');

                    if (chart) {
                        chart.destroy()
                    }

                    let chartColors = window.settings.ChartColors
                    if (chartColors) {
                        chartColors = chartColors.split(';')[0]
                    }

                    chart = new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: labels,
                            datasets: [{
                                label: 'AHN hoogte',
                                data: data,
                                borderWidth: 1,
                                borderColor: chartColors,
                                backgroundColor: chartColors
                            }]
                        },
                        options: {
                            interaction: {
                                display: true,
                                mode: "nearest",
                                axis: 'x',
                                intersect: false,
                            },
                            onHover: (e, item) => {
                                deselectFeature()
                                if (item.length > 0) {

                                    features.map(feature => {
                                        console.log('set style')
                                        feature.setStyle(new Style({}))
                                    })

                                    selectFeature(features[item[0].index])
                                } else {
                                    features.map(feature => {
                                        console.log('set style')
                                        feature.setStyle(null)
                                    })
                                }
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        title: context => {
                                            return 'Hoogte na ' + labels[context[0].dataIndex] + 'm';
                                        },
                                        label: context => {
                                            return context.dataset.label + ': ' + context.parsed.y + 'm';
                                        }
                                    }
                                }
                            }
                        }
                    });

                    const vectorLayer = new VectorLayer({
                        altitudeMode: 'clampToGround',
                        name: 'ahn-profile',
                        zIndex: 10000,
                        style: getDefaultStyleFunction(),
                        source: new VectorSource({
                            features: features,
                        }),
                    });

                    window.map.addLayer(vectorLayer)

                    window.activeChart = chart
                })
            }
        })

        function generateSegment(x, y) {
            return postGeoAhn({
                type: 'ahn2_05m_ruw',
                x: x.toFixed(2),
                y: y.toFixed(2)
            })
        }
    }
}

